import React from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Divider } from "@mui/material";

import SoftBox from "../../../../components/SoftBox";
import SoftTypography from "../../../../components/SoftTypography";
import SoftButton from "../../../../components/SoftButton";

const ActivateModal = ({ closeModal, children }) => {
  return (
    <>
      <SoftBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <SoftTypography
          variant="h4"
          color="white"
          sx={{ fontSize: "20px", fontWeight: 500, color: "#0F172A" }}
        >
          Activate Widget
        </SoftTypography>
        <SoftButton
          variant="outlined"
          color="white"
          onClick={closeModal}
          sx={{
            "& svg": { fontSize: "1.25rem !important" },
            borderRadius: "50%",
            minWidth: "max-content",
            minHeight: "max-content",
            padding: "0.25rem",
            // dark icon on light surface
            color: "#475467",
          }}
        >
          <CloseRoundedIcon />
        </SoftButton>
      </SoftBox>
      <Divider
        sx={{
          backgroundColor: "rgba(15,23,42,0.10)",
        }}
      />
      {children}
    </>
  );
};

export default ActivateModal;
